import React from "react";
import "./BenefitCard.scss";

const BenefitCard = ({ img, heading, para }) => {
  return (
    <div className="benefits-inner-box">
      <div className="benefitsdiv-img">
        <img src={img} alt="" />
      </div>

      <div>
        <h5>{heading}</h5>
        <p>{para}</p>
      </div>
    </div>
  );
};

export default BenefitCard;
